import { render } from "./orgProfileView.svg?vue&type=template&id=27bf926d"
const script = {}
script.render = render

export default script